import { ChangeEvent, FormEvent, useContext, useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { toast } from 'react-toastify'
import { ModalEstadoContext } from '../../contexts/ModalEstado'
import { converterNumero, criptografarDado, moedaMascara } from '../../helpers'
import { assinaturasItemResposta, paramsItemAssinaturaLista } from '../../interfaces/assinaturas'
import { listaCategoriasResposta } from '../../interfaces/categorias'
import { listaCentrosRespostaPayload } from '../../interfaces/centros'
import { atualizarItemAssinatura } from '../../services/assinaturas'
import { lisatarCategorias } from '../../services/categorias'
import { lisatarCentros } from '../../services/centros'
import { Button, Loader } from '../Styles'

function ModalItensAssinaturas({ itemAssinatura }: paramsItemAssinaturaLista) {

  const location = useLocation()

  const { modalSecundarioExibir, atualizarDados } = useContext(ModalEstadoContext)

  const { search } = location
  const params = new URLSearchParams(search)
  const tipo = params.get('tipo')

  const [processando, setProcessando] = useState(false)

  const [servicoLocal, setServicoLocal] = useState<assinaturasItemResposta>({
    idCategoria: itemAssinatura?.idCategoria,
    idCentro: itemAssinatura?.idCentro,
    descricao: itemAssinatura?.descricao,
    valor: itemAssinatura?.valor
  })
  const [categorias, setCategorias] = useState<listaCategoriasResposta[]>([]);
  const [centros, setCentros] = useState<listaCentrosRespostaPayload[]>([]);

  const atualizarItem = async (e: FormEvent) => {
    e.preventDefault()
    setProcessando(true)

    if (!itemAssinatura) {
      toast.error("Item da Assinatura não encontrado.")
      return setProcessando(false)
    }

    const idItemServicoCript = criptografarDado(itemAssinatura.id.toString())
    try {

      const payload = {
        idCategoria: servicoLocal.idCategoria,
        idCentro: servicoLocal.idCentro,
        descricao: servicoLocal.descricao,
        valor: converterNumero(servicoLocal.valor) / 100,
        idAssinatura: criptografarDado(itemAssinatura.idAssinatura.toString())
      }

      const resposta = await atualizarItemAssinatura(idItemServicoCript, payload)

      if (resposta.status === 200) {
        setProcessando(false)
        toast.success('Serviço Atualizado com Sucesso.')
        atualizarDados()
        modalSecundarioExibir("")
        return
      }

    } catch {
      toast.error('Falha ao Atualizar Serviço')
      return
    } finally {
      setProcessando(false)
    }
  }

  const aplicarMascaraValorServico = (e: ChangeEvent<HTMLInputElement>) => {
    return setServicoLocal({ ...servicoLocal, valor: moedaMascara(e.target.value) })
  }

  useEffect(() => {
    const buscarDadosIniciais = async () => {
      setProcessando(true)

      try {
        const [resCategorias, resCentros] = await Promise.all([
          lisatarCategorias({ descricao: '', situacao: 'ativa' }),
          lisatarCentros({ descricao: '', situacao: 'ativo' })
        ])

        if (resCategorias.status === 200) {
          setCategorias(resCategorias.data)
        }

        if (resCentros.status === 200) {
          setCentros(resCentros.data)
        }

      } catch {
        toast.error("Erro ao carregar os dados iniciais.")
      } finally {
        setProcessando(false)
      }
    }

    buscarDadosIniciais()
  }, [])

  return (
    <div className='fundoModal'>
      <section className='containerModalCentro'>
        <span className='novoContainerTitulo'>
          <h1>Atualizar Assinatura</h1>
        </span>
        <form className="container-form-inputs" onSubmit={atualizarItem}>
          <section>
            <span>
              <label>Descrição</label>
              <input
                value={servicoLocal.descricao}
                onChange={(e) => setServicoLocal({ ...servicoLocal, descricao: e.target.value })}
                placeholder='Descrição'
                type="text"
                required
              />
            </span>
          </section>
          <section>
            <span>
              <label>Valor</label>
              <input
                value={moedaMascara(servicoLocal.valor)}
                onChange={(e) => aplicarMascaraValorServico(e)}
                placeholder='R$ 0,00'
                type="text"
              />
            </span>
          </section>
          <section>
            <span>
              <label>Categoria</label>
              <select value={servicoLocal.idCategoria || ""} onChange={(e) => setServicoLocal({ ...servicoLocal, idCategoria: Number(e.target.value) })} required>
                <option value='' disabled selected>Selecione uma Categoria</option>
                {categorias.filter(categoria => categoria.tipo === tipo).map((categoria) => (
                  <option key={categoria.id} value={categoria.id}>{categoria.descricao}</option>
                ))}
              </select>
            </span>
          </section>
          <section>
            <span>
              <label>Centro de Resultado</label>
              <select value={servicoLocal.idCentro || ""} onChange={(e) => setServicoLocal({ ...servicoLocal, idCentro: Number(e.target.value) })} required>
                <option value='' disabled selected>Selecione uma Opção</option>
                {centros.filter((centro) => ["Centro de Resultado"].includes(centro.tipo)).map((centro) => (
                  <option key={centro.id} value={centro.id}>{centro.descricao}</option>
                ))}
              </select>
            </span>
          </section>
          <span id="botoesContainer">
            <Button type='button' cor='cancelar' isLoading={processando} onClick={() => modalSecundarioExibir("")}>Cancelar</Button>
            <Button type='submit' cor='salvar' isLoading={processando} disabled={processando}>
              {!processando && 'Salvar Dados'}
              {processando && <Loader isLoading={processando} />}
            </Button>
          </span>
        </form>
      </section>
    </div>
  )
}

export default ModalItensAssinaturas
